package one.healthium.profile.ui.profile

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.flow.onStart
import kotlinx.coroutines.flow.update
import one.healthium.base.preferences.AppPreferences
import one.healthium.domain.user.UserInteractor
import one.healthium.ui.common.vm.BaseViewModel

internal class ProfileViewModel(
    userInteractor: UserInteractor,
    appPreferences: AppPreferences,
) : BaseViewModel() {

    private val _state = MutableStateFlow(ProfileUiState())
    val state = _state.asStateFlow()

    init {
        combine(
            userInteractor.observeUser(),
            appPreferences.isMetricFlow,
            appPreferences.visitsInRowFlow,
        ) { user, isMetric, visitsInRow ->
            ProfileUiModel.fromModel(
                isMetric = isMetric,
                user = user,
                visitsInRow = visitsInRow,
            )
        }
            .catch {
                // TODO show error
                Logger.e("failed to fetch user", it)
                _state.update { state ->
                    state.copy(loading = false)
                }
            }
            .onStart {
                _state.update { state ->
                    state.copy(loading = true)
                }
            }
            .onEach { profile ->
                _state.update { state ->
                    state.copy(
                        loading = false,
                        profile = profile,
                    )
                }
            }
            .launch()
    }
}